import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Services from "@/pages/Services";

export const Route = createFileRoute("/es/servicios/")({
  head: () => buildRouteHead("/es/servicios"),
  component: Services,
});

